/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatAutocompleteTrigger, MatAutocomplete, MatOption } from '@angular/material/autocomplete';
import { CdAutocompletePositionDirective } from '../cd-autocomplete/cd-autocomplete-position.directive';
import { CdsIconModule } from '@cds/ng-web-components/icon';
import { CdsLanguageModule } from '@cds/ng-core/lang';

export interface CdDropdownTopping {
  label: string;
  value: string;
}

@Component({
  selector: 'app-cd-dropdown',
  templateUrl: './cd-dropdown.component.html',
  styleUrls: ['./cd-dropdown.component.scss'],
  imports: [
    NgClass,
    MatFormField,
    MatInput,
    FormsModule,
    MatAutocompleteTrigger,
    CdAutocompletePositionDirective,
    ReactiveFormsModule,
    MatAutocomplete,
    MatOption,
    CdsIconModule,
    CdsLanguageModule,
  ],
})
export class CdDropdownComponent implements OnInit {
  @Input() group!: FormGroup;
  @Input() controlName = '';
  @Input() label = '';
  @Input() placeholder = '';
  @Input() toppingList: CdDropdownTopping[] = [];
  @Input() disabled = false;
  private _selected?: string;
  @Input()
  set selected(selected: string) {
    this._selected = selected;
    this.valueControl.setValue(this._selected);
  }
  @Output() selectedChange = new EventEmitter<any>();
  valueControl = new FormControl('');
  open = false;
  toppings: CdDropdownTopping[] = [];
  constructor() {}

  ngOnInit(): void {
    this.valueControl.valueChanges.subscribe(() => {
      this.selectedChange.emit(this.valueControl.value);
    });

    if (this.group) {
      this.group.controls[this.controlName].valueChanges.subscribe(() => {
        this.selectedChange.emit(this.valueControl.value);
      });
    }
  }

  get showVaule() {
    const value = this.group ? this.group.controls[this.controlName].value : this.valueControl.value;
    const option = this.toppingList.filter(item => item.value === value);
    if (option.length > 0) {
      return option[0].label;
    }
    return '';
  }

  blur() {
    setTimeout(() => {
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
    }, 0);
  }

  onOpened(auto: MatAutocomplete) {
    this.open = true;
    setTimeout(() => {
      this.applySolidPanelStyle(auto);
    }, 0);
  }

  private applySolidPanelStyle(auto: MatAutocomplete) {
    const panelElement = auto.panel?.nativeElement as HTMLElement | undefined;
    if (!panelElement) {
      return;
    }

    const overlayPane = panelElement.closest('.cdk-overlay-pane') as HTMLElement | null;
    if (overlayPane) {
      overlayPane.style.marginTop = '10px';
    }

    panelElement.classList.add('cd-dropdown-solid-panel');
    panelElement.style.background = '#fff';
    panelElement.style.backgroundColor = '#fff';
    panelElement.style.opacity = '1';
    panelElement.style.marginTop = '10px';
    panelElement.style.padding = '0';
    panelElement.style.border = '1px solid var(--cds-divider-default)';
    panelElement.style.borderRadius = '0';
    panelElement.style.boxShadow = 'none';
    panelElement.style.setProperty('--mdc-menu-container-color', '#fff');
    panelElement.style.setProperty('--mat-autocomplete-background-color', '#fff');

    panelElement.querySelectorAll<HTMLElement>('.mat-mdc-option').forEach(option => {
      option.style.background = '#fff';
      option.style.backgroundColor = '#fff';
    });
  }

  onClosed() {
    this.open = false;
    this.blur();
  }

  clearValue() {
    this.valueControl.setValue('');
  }
}
